export default __webpack_public_path__ + "static/media/uhcLogo.328d2fd7.svg";